export const isDedicatedTenantManager = (roles: string[]): boolean =>
  roles.includes("TENANT_MANAGER") && !roles.includes("TENANT_ADMIN") && !roles.includes("AIL_ADMIN");

export const isDedicatedTenantAdmin = (roles: string[]): boolean =>
  roles.includes("TENANT_ADMIN") && !roles.includes("AIL_ADMIN");

export const getAuthenticatedLandingRoute = (roles: string[]): string =>
  isDedicatedTenantAdmin(roles)
    ? "/tenant-admin-dashboard"
    : isDedicatedTenantManager(roles)
      ? "/tenant-manager-dashboard"
      : "/home";
